import * as yup from 'yup';
import i18n from 'i18next';

export const FormSchema = yup.object({
  email: yup
    .string()
    .email(i18n.t('invalid_email_error', { ns: 'misc' }))
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, i18n.t('invalid_email_error', { ns: 'misc' }))
    .required(i18n.t('required', { ns: 'common' })),
  firstName: yup.string().required(i18n.t('required', { ns: 'common' })),
  surname: yup.string().required(i18n.t('required', { ns: 'common' })),
  street: yup.string().required(i18n.t('required', { ns: 'common' })),
  number: yup.string().required(i18n.t('required', { ns: 'common' })),
  city: yup.string().required(i18n.t('required', { ns: 'common' })),
  zipCode: yup.string().required(i18n.t('required', { ns: 'common' })),
  agreed: yup.boolean().required(i18n.t('required', { ns: 'common' })),
});
